import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {ForgotPasswordMutationType} from "./__graphql-types__/index.ts";

export const FORGOT_PASSWORD_MUTATION: GqlOperation<
    ForgotPasswordMutationType["response"],
    ForgotPasswordMutationType["variables"]
> = gqlOp(gql`
    mutation ForgotPasswordMutation($email: String!) {
        forgotPassword(email: $email) {
            error {
                code
            }
        }
    }
`);
